import { jsxs, jsx } from "react/jsx-runtime";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMenuItemLink } from "../hooks/useMenuItemLink.js";
const MenuItemButton = ({
  url,
  target,
  iconNode,
  label,
  sx = {},
  children,
  variant = "body2",
  fontWeight = 400,
  collapsed = false,
  transitioning = false,
  compact = false
}) => {
  const resolvedVariant = compact && variant === "body2" ? "caption" : variant;
  const { linkProps } = useMenuItemLink({ url, target });
  return /* @__PURE__ */ jsxs(
    ListItemButton,
    {
      ...linkProps,
      sx: {
        padding: compact ? "10px 20px" : "12px 20px",
        ...collapsed && { justifyContent: "center", px: 0 },
        ...sx
      },
      children: [
        iconNode && /* @__PURE__ */ jsx(
          ListItemIcon,
          {
            sx: {
              minWidth: collapsed ? 0 : 28,
              width: collapsed ? "auto" : 28,
              marginRight: collapsed ? 0 : 1.5,
              justifyContent: "center",
              color: "inherit",
              "& svg": {
                fontSize: "20px"
              }
            },
            children: iconNode
          }
        ),
        !collapsed && /* @__PURE__ */ jsxs(
          Stack,
          {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            sx: { flex: 1, minWidth: 0, overflow: "hidden" },
            children: [
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: resolvedVariant,
                  sx: {
                    fontWeight,
                    ...transitioning && {
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }
                  },
                  children: label
                }
              ),
              children
            ]
          }
        )
      ]
    }
  );
};
export {
  MenuItemButton
};
